<template>
  <v-card class="card-pad mx-auto" width="900">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn
            depressed
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="alterDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            depressed
            :loading="loading"
            class="ma-1"
            color="#B14949"
            text
            @click="closeDialog"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
    <div class="d-flex align-center justify-center my-3">
      <h2>{{ $t(title) }}</h2>
      <v-alert
        type="error"
        v-show="error"
        transition="scale-transition"
        icon="mdi-alert-octagon-outline"
      >
        {{ $t('errorMessage') }}
      </v-alert>
    </div>
    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form class="form" ref="firstForm" lazy-validation>
          <v-row class="ma-0" dense>
            <v-col class="py-0" cols="12"> </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense justify="center">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label ml-1">{{ $t('Tipo de consumo') }}</label>
              <v-select
                class="primary-input"
                :items="typeList"
                v-model="readingConsumption.consumptionTypeId"
                :disabled="isEditing"
                :rules="[(v) => !!v || 'Tipo obrigatório']"
                @change="changePoints()"
                item-text="name"
                item-value="id"
                outlined
                hide-details="auto"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label ml-1">{{ $t('Ponto de leitura') }}</label>
              <v-select
                class="primary-input"
                :items="pointList"
                v-model="readingConsumption.consumptionPointId"
                :disabled="isEditing"
                :rules="[(v) => !!v || 'Ponto de consumo obrigatório']"
                item-text="name"
                item-value="id"
                outlined
                hide-details="auto"
                @change="getLastValue()"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <span class="text ml-1">{{
                unityValue
                  ? $t('Valor em ') + unityValue
                  : $t('Valor em unidade')
              }}</span>
              <v-text-field
                :rules="[(v) => !!v || 'Valor obrigatório']"
                v-model="readingConsumption.total"
                :suffix="suffixvalue ? suffixvalue : ''"
                type="number"
                class="primary-input"
                outlined
                hide-details="auto"
                hide-spin-buttons
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="text ml-1">{{
                unityValue
                  ? $t('Preço por ') + unityValue
                  : $t('Valor por unidade')
              }}</span>
              <v-currency-field
                v-model="readingConsumption.unityValue"
                :rules="[(v) => !!v || 'Unidade obrigatório']"
                class="primary-input"
                :decimalLength="3"
                placeholder="0,000"
                outlined
                hide-details="auto"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-currency-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-row class="ma-0 pa-0">
                <span class="text ml-1">{{ $t('Data do relatório') }}</span>
                <v-col class="ma-0 pa-0" cols="12">
                  <date-picker
                    ref="datepicker"
                    style="width: 100%"
                    v-model="checklistStartDate"
                    mode="dateTime"
                    is24hr
                    :popover="{ visibility: 'click', positionFixed: 'true' }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        :class="
                          checklistStartDateError
                            ? 'date-input-error'
                            : 'date-input'
                        "
                        :value="inputValue"
                        v-on="inputEvents"
                        v-mask="['##/##/#### ##:##']"
                        @focus="setLaborNowDate"
                      />
                      <span
                        class="date-span-error"
                        v-if="checklistStartDateError"
                      >
                        {{ $t('Data é requerida') }}
                      </span>
                    </template>
                  </date-picker>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              reading
                ? $t('Leitura atualizada com sucesso!')
                : $t('Leitura cadastrada com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>
    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6">
      <v-btn depressed @click="close" class="secondary-button">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        class="primary-button mr-0"
        @click="next"
        :loading="loading"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import FormatDate from '../../../../Utils/FormatDate'
import Utils from '../../../../Utils/FormatDate'

export default {
  props: {
    title: String,
    reading: Object,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.readingConsumption.institutionId = this.institution.id
    // this.startDate = new Date()
    await this.listTypes()
    if (this.reading != null) {
      this.isEditing = true
      this.readingConsumption.consumptionTypeId = this.reading.consumptionTypeId
      this.changePoints()
      this.readingConsumption.consumptionPointId =
        this.reading.consumptionPointId
      this.readingConsumption.total = this.reading.total
      this.readingConsumption.id = this.reading.id
      this.readingConsumption.readingDate = this.reading.readingDate
      this.readingConsumption.unityValue = this.reading.unityValue
      this.startDate = this.formatDate(this.reading.readingDate)
      this.checklistStartDate = this.reading.readingDate
    } else {
      this.checklistStartDate = new Date()
    }
  },

  data: () => ({
    unityValue: null,

    startDate: null,
    checklistStartDate: null,
    checklistStartDateError: false,
    menuStartDate: false,
    suffixvalue: null,
    readingConsumption: {
      readingDate: null,
      institutionId: 0,
      consumptionTypeId: 0,
      consumptionPointId: 0,
      value: null,
      unityValue: null,
    },

    loading: false,
    step: 0,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    error: false,
    errorMessage: '',
    isEditing: false,
    apiService: new ApiService(),
    typeList: [],
    pointList: [],
    institution: {},
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.reading ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  watch: {
    checklistStartDate: {
      deep: true,
      handler() {
        this.checklistStartDateError = false
      },
    },
  },
  methods: {
    setLaborNowDate() {
      this.checklistStartDate = !this.checklistStartDate
        ? new Date()
        : this.checklistStartDate
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatDate(date) {
      return FormatDate.moment(date)
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.checklistStartDate)
      this.$refs.menuStartDate.save(date)
    },
    closeDialog() {
      this.changedData = false
      this.close()
    },
    async listTypes() {
      await this.apiService
        .get(`consumptiontype/list?institutionId=${this.institution.id}`)
        .then((response) => {
          this.typeList = response.content
        })
    },
    async getLastValue() {
      await this.apiService
        .get(
          `consumptionreading/get-last-value?consumptionPointId=${this.readingConsumption.consumptionPointId}&institutionId=${this.institution.id}`
        )
        .then((response) => {
          this.readingConsumption.unityValue = response.content
        })
    },
    async submit() {
      this.loading = true
      this.readingConsumption.readingDate = Utils.nowDatetimeFormat(
        this.checklistStartDate
      )

      this.readingConsumption.value = this.readingConsumption.total

      if (this.reading) {
        await this.apiService
          .put(`consumptionreading`, this.readingConsumption)
          .then(() => {
            this.$toast.success(this.$t('Leitura atualizada com sucesso!'))

            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        await this.apiService
          .post('consumptionreading', this.readingConsumption)
          .then(() => {
            this.$toast.success(this.$t('Leitura cadastrada com sucesso!'))
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }

      this.loading = false
      this.changedData = false
    },
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },
    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.checklistStartDate) {
          await this.submit()
          if (!this.error) {
            this.step += 1
          }
        } else {
          this.checklistStartDateError = true
        }
      } else {
        this.closeDialog()
      }
    },
    changePoints() {
      const type = this.typeList.find(
        (x) => x.id == this.readingConsumption.consumptionTypeId
      )
      this.pointList = type.consumptionPoints
      this.suffixvalue = type.unityName

      this.unityValue = type.unityName
    },
  },
}
</script>
